import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { SubmissionService } from '../shared/service/submission.service';
import { Submission } from 'app/shared/class/submission';
import { User } from 'app/shared/class/user';
import { MtPipe } from '../mt.pipe';

@Component({
    selector: 'app-catex',
    templateUrl: './catex.component.html',
    styleUrls: ['./catex.component.css'],
    standalone: true,
    imports: [CommonModule, MtPipe]
})
export class CatexComponent implements OnInit {

  submission: Submission;
  procedureDescription: string;
  designer: User;
  aptContact: User;
  catex: Array<any>;

  fullName: Array<any> = [];

  catexExplanation: string[] = [
    'Rulemaking actions that designate or modify classes of airspace areas, airways, routes, and reporting points (see 14 CFR part 71, Designation of Class A, B, C, D, and E Airspace Areas; Air Traffic Service Routes; and Reporting Points). (ATO)',
    'Actions regarding establishment of jet routes and Federal airways (see 14 CFR § 71.15, Designation of jet routes and VOR Federal airways); operation of civil aircraft in a defense area, or to, within, or out of the United States through a designated Air Defense Identification Zone (ADIZ) (14 CFR part 99, Security Control of Air Traffic); authorizations for operation of moored balloons, moored kites, amateur rockets, and unmanned free balloons (see 14 CFR part 101, Moored Balloons, Kites, Amateur Rockets and Unmanned Free Balloons); and, authorizations of parachute jumping and inspection of parachute equipment (see 14 CFR part 105, Parachute Operations). (ATO)',
    'Establishment or modification of helicopter or eVTOL routes that channel helicopter activity over major thoroughfares and do not have the potential to significantly increase noise over noise sensitive areas. (ATO, AVS)',
    'Establishment of new or revised air traffic control procedures conducted at 3,000 feet or more above ground level (AGL); procedures conducted below 3,000 feet AGL that  do not cause traffic to be routinely routed over noise sensitive areas; modifications to currently  approved procedures conducted below 3,000 feet AGL that do not significantly increase noise over  noise sensitive areas; and increases in minimum altitudes and landing minima. For modifications to  air traffic procedures at or above 3,000 feet AGL, the Aviation Environmental Design Tool (AEDT) or other FAA-approved  environmental screening methodology should be applied. (ATO, AVS)',
    'Implementation of procedures to respond to emergency air or ground safety needs, accidents, or natural events with no reasonably foreseeable long-term adverse impacts. (ATO)',
    'Publication of existing air traffic control procedures that do not essentially change existing tracks, create new tracks, change altitude, or change the concentration of aircraft on these tracks. (ATO, AVS)',
    'Establishment of new procedures that routinely route aircraft over non-noise sensitive areas. (ATO, AVS)'
  ]; 

  constructor(private subService: SubmissionService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(
      (r) => {
        this.subService.getSubmission(r.id).subscribe(
          (r) => {
            if (!r) {
              this.router.navigate(['/home']);
            } else {
              this.submission = r;
              this.designer = new User(r['ProcedureDesigner']);
              var val = r['AirportContact'];
              if (val) {
                this.aptContact = new User(val);
              }
              
              if (this.submission.procedureDescriptionForCATEX && this.submission.procedureDescriptionForCATEX.length > 0) {
                this.procedureDescription = this.submission.procedureDescriptionForCATEX;
              } else {
                this.procedureDescription = this.submission.procedureDescription;
              }

              if (r.ProcedureDetails.length>0){
                this.fullName[0]='1) ' + r.procedureName;
              } else{
                this.fullName[0]=r.procedureName;
              }

              for (var i = 0; i < r.ProcedureDetails.length; i++) {
                this.fullName[i+1]=(i+2) + ') ' + r.ProcedureDetails[i].procedureName;  
              } 

              this.catex = [];
              var code = ['a','b','h', 'i', 'j', 'k', 'p'];
              for (var i = 0; i < code.length; i++) {
                if (this.submission['IsCATEX_' + code[i]]) {
                  this.catex.push({
                    code: 'B-2.5.' + code[i],
                    val: this.catexExplanation[i]
                  });
                }
              }
            }
          }
        )
      })
  }

}
